import React from "react";

import { Button, Modal } from "shared/ui";
import { localizedText } from "shared/lib/localizedMap";

import { useMenuItemBadgesContext } from "features/MenuItemBadges/context";

export const DeleteBadgeDialog = () => {
    const state = useMenuItemBadgesContext();
    const { badgeToDelete } = state;

    return (
        <Modal
            open={!!badgeToDelete}
            onClose={state.closeDeleteDialog}
            title="Удаление бейджа"
            maxWidth="xs"
            actions={
                <>
                    <Button variant="outlined" color="neutral" onClick={state.closeDeleteDialog}>
                        Отмена
                    </Button>
                    <Button
                        variant="contained"
                        color="danger"
                        disabled={state.saving}
                        onClick={state.confirmDelete}
                    >
                        Удалить
                    </Button>
                </>
            }
        >
            Бейдж «{badgeToDelete ? localizedText(badgeToDelete.title, state.locale) : ""}» будет
            удалён и снят со всех позиций меню. Отменить это действие нельзя. Если бейдж нужно
            просто убрать из меню — выключите его тумблером, тогда позиции останутся отмеченными.
        </Modal>
    );
};
